export default function userMessage(value: unknown): string {
  if (value instanceof Error && value.message) return value.message;
  if (typeof value === 'string' && value) return value;
  if (
    value &&
    typeof value === 'object' &&
    'error' in value &&
    typeof value.error === 'string' &&
    value.error
  ) {
    return value.error;
  }
  if (
    value &&
    typeof value === 'object' &&
    'message' in value &&
    typeof value.message === 'string' &&
    value.message
  ) {
    return value.message;
  }
  return 'Something went wrong. Please try again.';
}
